import { withProtocol } from "ufo";

const cloudApiFallback = window.AXSHARE_HOST_SECURE_URL // use standalone base url if exists
  || window.location.origin;

export const cloudApiUrl = import.meta.env.VITE_CLOUD_API_URL || cloudApiFallback;
export const serverApiUrl = import.meta.env.DEV ? import.meta.env.VITE_DISKO_SERVER_URL : new URL("api/disko/", cloudApiFallback).toString();
export const textServiceUrl = import.meta.env.DEV ? import.meta.env.VITE_DISKO_TEXT_SERVICE_URL : new URL("api/disko/text-service/", cloudApiFallback).toString();

export const textServiceWSUrl = withProtocol(textServiceUrl, import.meta.env.PROD ? "wss://" : "ws://");
